<template>
  <modal v-if="isOpen" class-name="contact-modal" @close="closeModal">
    <template #header>
      <h4 :class="{ 'contact-modal__success-title': isSuccessMessage }">
        {{ !isSuccessMessage ? 'Haben Sie Fragen zu Ihrer Bestellung?' : 'Vielen Dank!' }}
      </h4>
    </template>
    <template #body>
      <div v-if="!isSuccessMessage" class="contact-modal__content">
        <p>
          Schreiben Sie hier Ihre Fragen und wir werden uns schnellstmöglich mit Ihnen in
          Verbindung setzen!
        </p>
        <form>
          <div :class="{ 'with-error': phoneError }">
            <label for="contact-phone">Ihre Telefonnummer</label>
            <input id="contact-phone" v-model="phone" />
            <p v-if="phoneError" class="error-message">{{ phoneError }}</p>
          </div>
          <div :class="{ 'with-error': messageError }">
            <label for="contact-message">Ihre Nachricht</label>
            <textarea id="contact-message" v-model="message" />
            <p v-if="messageError" class="error-message">Bitte füllen Sie das Textfeld aus!</p>
          </div>
          <button class="btn btn-red" type="submit" :disabled="sending" @click="sendMessage">
            Absenden
          </button>
        </form>
      </div>
      <p v-else class="contact-modal__success-text">
        Ihre Nachricht wurde versendet. Wir werden uns schnellstmöglich mit Ihnen in Verbindung
        setzen.
      </p>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';
import { sendContactForm } from '@/api/checkout';

export default {
  components: {
    Modal,
  },
  props: ['isOpen', 'carId'],
  data() {
    return {
      message: '',
      messageError: '',
      phone: '',
      phoneError: '',
      sending: false,
      isSuccessMessage: false,
    };
  },
  methods: {
    sendMessage(e) {
      e.preventDefault();
      const isValid = this.validateForm();
      if (isValid) {
        this.sending = true;
        const params = {
          email: 'onlinekauf@pkw.de',
          name: 'CheckoutUser',
          contact_note: this.message,
          phone: this.phone,
        };
        sendContactForm(this.carId, params).then(() => {
          this.sending = false;
          this.isSuccessMessage = true;
        });
      }
    },
    validatePhone(value) {
      const phoneRe = /^\+?\d+(-\d+)*$/;
      const digits = value.replace(/\D/g, '');
      return phoneRe.test(digits);
    },
    validateForm() {
      let noError = true;
      if (!this.message) {
        this.messageError = true;
        noError = false;
      } else {
        this.messageError = '';
      }
      if (!this.phone) {
        this.phoneError = 'Dies ist ein Pflichtfeld.';
        noError = false;
      } else if (this.phone.length < 10 && !this.validatePhone(this.phone)) {
        this.phoneError = 'Bitte geben Sie eine gültige Telefonnummer ein.';
        noError = false;
      } else {
        this.phoneError = '';
      }
      if (noError) {
        this.messageError = '';
        this.phoneError = '';
      }
      return noError;
    },
    closeModal() {
      this.message = '';
      this.phone = '';
      this.sending = false;
      this.messageError = '';
      this.phoneError = '';
      this.isSuccessMessage = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-modal {
  h3 {
    margin-bottom: 0.3125rem;
    font-size: 0.875rem;
    font-weight: 700;
  }
  h4 {
    margin-bottom: 0.625rem;
  }
  .error-message {
    display: none;
    margin-top: 0.3125rem;
    font-size: 0.875rem;
    font-weight: 700;
    text-align: center;
    color: $red;
  }
  &__success-title {
    font-weight: 700;
    text-align: center;
    color: $darkgray;
  }
  &__success-text {
    max-width: 19.0625rem;
    margin: 0 auto;
    font-size: 0.875rem;
  }
  &__content {
    p {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
    form {
      margin: 0.9375rem 0;
      label {
        font-size: 0.875rem;
        font-weight: 700;
      }
      input,
      textarea {
        width: 100%;
        height: 10rem;
        margin-top: 0.625rem;
        padding: 0.3125rem;
        border: 0.0625rem solid #e3e3e3;
        font-size: 0.875rem;
        &:focus {
          outline: none;
        }
      }
      input {
        margin-bottom: 10px;
        height: auto;
      }
      button {
        margin-top: 0.9375rem;
        &:disabled {
          opacity: 0.8;
        }
      }
      .with-error {
        input,
        textarea {
          border-color: $red;
        }
        .error-message {
          display: block;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.contact-modal {
  .modal-wrapper {
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
